import styled, { css } from 'styled-components';

const A11yHidden = css`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
`;

export const Container = styled.div`
  ${A11yHidden}
`;
